/**
 * Zoekfilter voor werklijsten (WI-nummer, WB-nummer, productnaam, klantnaam).
 *
 * Null-veilig, en dat is geen cosmetica: op 12-09 t/m 15-09 stond er één
 * kleed zonder WI-nummer (name null, aanmaakgat 10-09) in de Foto Tijdens-
 * lijst. Elke `item.itemName.toLowerCase()` gooide dan een TypeError in de
 * render, React ontkoppelde de hele pagina en de wasser zag een wit scherm
 * zodra hij een nummer intikte. Vier werklijsten hadden exact dezelfde regel.
 * Een veld dat ontbreekt matcht niet; de rest van de lijst blijft werken.
 */
export function matchtZoek(query: string, ...velden: Array<string | null | undefined>): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return velden.some((v) => typeof v === 'string' && v.toLowerCase().includes(q));
}
